import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=c3f860ea&scoped=true"
import script from "./NewsComponent.vue?vue&type=script&lang=js"
export * from "./NewsComponent.vue?vue&type=script&lang=js"
import style0 from "./NewsComponent.vue?vue&type=style&index=0&id=c3f860ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f860ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarrouselV3: require('/home/luiz/Sistemas/loja/components/Carrousel/V3.vue').default,CarrouselV2: require('/home/luiz/Sistemas/loja/components/Carrousel/V2.vue').default,ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
